import { createUseStyles } from 'react-jss';

import { mediaQuery } from '../../../styles/helpers';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles<string, { orientation: 'row' | 'column' }, ITheme>(
  ({ breakpoints }: ITheme) => ({
    withBorder: {
      '& li': {
        width: '100%',
        padding: [14, 16],
        backgroundColor: 'var(--x-bg-12)',
        border: '2px solid var(--x-bg-8)',
        borderRadius: 12,
        '& span': {
          fontSize: 16,
          lineHeight: '16px',
        },
        [mediaQuery(breakpoints.tablet)]: {
          width: 'auto',
          padding: 0,
          backgroundColor: 'transparent',
          borderWidth: 0,
          '& span': {
            fontSize: 12,
            lineHeight: '16px',
          },
        },
      },
    },
    root: {
      flex: '0 0 206px',

      [mediaQuery(breakpoints.mobile)]: {
        top: 58,
      },
    },

    list: {
      listStyleType: 'none',
      display: 'flex',
      flexDirection: ({ orientation }) => orientation,
      gap: ({ orientation }) => (orientation === 'column' ? 12 : 13),
      marginBottom: ({ orientation }) => (orientation === 'column' ? 12 : 0),
    },

    heading: {
      fontSize: '0.75rem',
      fontWeight: 600,
      marginBlockEnd: 16,
      textTransform: 'uppercase',
    },
    item: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',

      '&>:first-child': {
        marginRight: 8,
      },
    },
    link: {
      outline: 'none',
      textDecoration: 'none',

      '&.isSelected': {
        cursor: 'default',
      },
    },
  }),
  {
    name: 'PillsButtons',
  },
);

export default useStyles;
